<template>
    <l-map
        ref="myMap"
        id="map"
        :zoom="map.zoom"
        :center="map.center"
        :options="map.options"
        :crs="map.crs"
        @click="eventClick"
        @zoomend="zoomEnd"
        @update:bounds="updateBounds"
    >
        <!-- ICONE DE RECHERCHE (inactif pour le moment)
        <l-control position="topright" class="leaflet-bar leaflet-control">
            <SearchControl />
        </l-control>
        -->

        <l-control position="topright" class="leaflet-bar leaflet-control" v-if="activeObject">
            <a href="#" @click.stop="activeObject2" title="Zoomer sur l'objet sélectionné">
                <font-awesome-icon icon="crosshairs" class="fa-lg" />
            </a>
        </l-control>
        <l-control
            position="topright"
            class="leaflet-bar leaflet-control"
            style="display: none;"
            v-else
        >
            <a href="#" @click.stop> <font-awesome-icon icon="crosshairs-fo" class="fa-lg" /> </a>
        </l-control>

        <l-control position="topright" class="leaflet-bar leaflet-control">
            <Select
                class="select-footprint"
                name="footprint"
                :options="footprintsList"
                :value="footprintsList.find((e) => e.id === emprise.id)"
                @input="changeEmprise"
                v-if="emprise.id"
            />
        </l-control>

        <l-control position="topright" class="leaflet-bar leaflet-control">
            <a href="#" @click.stop="fitEmprise" title="Zoomer sur l'emprise de travail">
                <font-awesome-icon icon="map" class="fa-lg" />
            </a>
        </l-control>

        <l-control-layers
            position="topright"
            auto-z-index="true"
            sort-layers="true"
            class="control-layers--fix"
        ></l-control-layers>

        <!-- ICONE D'AIDE (inactif pour le moment)
        <l-control position="topright" class="leaflet-bar leaflet-control">
            <a href="#" @click.stop="handleHelp">
                <font-awesome-icon icon="question" class="fa-lg" />
            </a>
        </l-control>
        -->

        <l-control-zoom
            position="topright"
            :zoomInTitle="zoomControl.zoomInTitle"
            :zoomOutTitle="zoomControl.zoomOutTitle"
        ></l-control-zoom>

        <!-- Tuiles de fond (tiles) -->
        <l-tile-layer
            v-for="tile in tiles"
            :key="tile.name"
            :name="tile.name"
            :visible="tile.visible"
            :url="
                tile.layer
                    ? `${tile.url}/${tile.layer}/{z}/{x}/{y}.${tile.format.replace('image/', '')}`
                    : `${tile.url}/{z}/{x}/{y}.${tile.format.replace('image/', '')}`
            "
            :attribution="tile.attribution"
            :token="token"
            layer-type="base"
            z-index="650"
        />

        <!-- WMTS BASE URL -->
        <l-tile-layer
            v-for="wmtslayer in wmtslayersBaseUrl"
            :key="wmtslayer.name"
            :name="wmtslayer.name"
            :visible="wmtslayer.visible"
            :url="
                wmtslayer.url +
                    '?&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=' +
                    wmtslayer.style +
                    '&TILEMATRIXSET=' +
                    wmtslayer.matrixset +
                    '&FORMAT=' +
                    wmtslayer.format +
                    '&LAYER=' +
                    wmtslayer.layer +
                    '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'
            "
            :attribution="wmtslayer.attribution"
            :token="token"
            :layer-type="wmtslayer.type"
            z-index="698"
        />

        <!-- WMTS BASE REST -->
        <l-tile-layer
            v-for="wmtslayer in wmtslayersBaseRest"
            :key="wmtslayer.name"
            :name="wmtslayer.name"
            :visible="wmtslayer.visible"
            :url="
                wmtslayer.url +
                    '/tile/1.0.0/' +
                    wmtslayer.layer +
                    '/' +
                    wmtslayer.style +
                    '/' +
                    wmtslayer.matrixset +
                    '/{z}/{y}/{x}'
            "
            :attribution="wmtslayer.attribution"
            :token="token"
            :layer-type="wmtslayer.type"
            z-index="698"
        />

        <!-- WMS BASE -->
        <l-wms-tile-layer
            v-for="wmslayer in wmslayersBase"
            :key="wmslayer.name"
            :base-url="wmslayer.url"
            :layers="wmslayer.layer"
            :visible="wmslayer.visible"
            :name="wmslayer.name"
            :format="wmslayer.format"
            :transparent="wmslayer.alpha"
            :layer-type="wmslayer.type"
            :options="{ attribution: wmslayer.attribution, maxZoom: wmslayer.maxzoom }"
            z-index="699"
        />

        <!-- WMTS OVERLAY URL -->
        <l-tile-layer
            v-for="wmtslayer in wmtslayersOverlayUrl"
            :key="wmtslayer.name"
            :name="wmtslayer.name"
            :visible="wmtslayer.visible"
            :url="
                wmtslayer.url +
                    '?&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=' +
                    wmtslayer.style +
                    '&TILEMATRIXSET=' +
                    wmtslayer.matrixset +
                    '&FORMAT=' +
                    wmtslayer.format +
                    '&LAYER=' +
                    wmtslayer.layer +
                    '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}'
            "
            :attribution="wmtslayer.attribution"
            :token="token"
            :layer-type="wmtslayer.type"
            z-index="700"
        />

        <!-- WMTS OVERLAY REST -->
        <l-tile-layer
            v-for="wmtslayer in wmtslayersOverlayRest"
            :key="wmtslayer.name"
            :name="wmtslayer.name"
            :visible="wmtslayer.visible"
            :url="
                wmtslayer.url +
                    '/tile/1.0.0/' +
                    wmtslayer.layer +
                    '/' +
                    wmtslayer.style +
                    '/' +
                    wmtslayer.matrixset +
                    '/{z}/{y}/{x}'
            "
            :attribution="wmtslayer.attribution"
            :token="token"
            :layer-type="wmtslayer.type"
            z-index="698"
        />

        <!-- WMS OVERLAY -->
        <l-wms-tile-layer
            v-for="wmslayer in wmslayersOverlay"
            :key="wmslayer.name"
            :base-url="wmslayer.url"
            :layers="wmslayer.layer"
            :visible="wmslayer.visible"
            :name="wmslayer.name"
            :format="wmslayer.format"
            :transparent="wmslayer.alpha"
            :layer-type="wmslayer.type"
            :options="{
                attribution: wmslayer.attribution,
                maxZoom: wmslayer.maxzoom,
            }"
            z-index="701"
        />

        <!-- Affichage de l'objet si le zoom est suffisant -->
        <l-geo-json
            v-if="activeObject && !largeView"
            :geojson="geojson"
            :options="geojsonOptions"
        />

        <!-- Sinon affichage d'un cercle et d'un rectangle (pour les longues relations) -->
        <l-circle-marker
            v-if="activeObject && largeView"
            :lat-lng="center"
            :color="activeObject.color"
            :fill-color="activeObject.color"
            :radius="15"
            :opacity="1"
            :fill-opacity="0.5"
            :weight="2"
        />
        <l-rectangle
            v-if="activeObject && largeView"
            :bounds="bounds"
            :color="activeObject.color"
            :fill-color="activeObject.color"
            :opacity="1"
            :fill-opacity="0.4"
            :weight="2"
        />

        <!-- Affichage de l'emprise -->
        <l-geo-json :geojson="emprise.geojson" :options="emprise.options" />

        <l-control-scale position="bottomright" :imperial="false" :metric="true"></l-control-scale>
    </l-map>
</template>

<script>
//import SearchControl from '@/components/map/SearchControl';

import {
    LMap,
    LControlLayers,
    LControlZoom,
    LControl,
    LTileLayer,
    LWMSTileLayer,
    LGeoJson,
    LCircleMarker,
    LRectangle,
    LControlScale,
    //LFeatureGroup,
    //LMarker,
    //LLayerGroup,
} from 'vue2-leaflet';
import { geoJSON, CRS, circleMarker } from 'leaflet';
import Select from '@/components/Select';

// Valeurs par défaut centrées sur la France - La carte est ensuite recentrée sur l'emprise spécifiée en admin.
// Montpellier // const MAP_CENTER = [43.61092, 3.87723];
const MAP_CENTER = [46, 2];
const ZOOM = 6;

// Permet de ne lancer une fonction qu'après un certain délai
// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this,
            args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export default {
    props: {
        activeObject: Object,
        objectLayers: Array,
        overlayOffset: Number,
        popup: Object,
    },
    data() {
        return {
            settings: {
                osm_footprint: null,
                osm_footprint_pen_color: null,
                osm_footprint_pen_opacity: null,
                osm_footprint_fill_color: null,
                osm_footprint_fill_opacity: null,
                osm_footprint_width: null,
            },

            loaded_settings: [],

            emprise: {
                id: null,
                geojson: null,
                bounds: null,
                options: {
                    style: {
                        weight: null,
                        color: null,
                        opacity: null,
                        fillColor: null,
                        fillOpacity: null,
                    },
                },
            },

            zoomControl: {
                zoomInTitle: 'Zoomer',
                zoomOutTitle: 'Dézoomer',
            },
            map: {
                zoom: ZOOM,
                center: MAP_CENTER,
                bounds: null,
                crs: CRS.EPSG3857,
                options: {
                    zoomControl: false,
                },
            },
            tiles: [],
            wmslayers: [],
            wmtslayers: [],
            largeView: false,
            center: null,
            bounds: null,
            popupLayer: null,
            footprints: [],
            footprintsList: [],
        };
    },
    watch: {
        overlayOffset: function(newVal, oldVal) {
            const map = this.$refs.myMap.mapObject;
            const center = map.getCenter();
            const offset = Number.parseInt(newVal) - Number.parseInt(oldVal);
            this.adjustCenter(center, offset);
        },
        activeObject: function() {
            let center = MAP_CENTER;
            let bounds = null;
            if (this.activeObject) {
                const { new_geom, old_geom, color, od_extent } = this.activeObject;
                let lonMin, lonMax, latMin, latMax, lonCenter, latCenter;
                const features = this.getGeoJSONFeatures(new_geom, old_geom, color);

                if (od_extent) {
                    const extent = od_extent.split(';');
                    lonMin = extent[0];
                    lonMax = extent[2];
                    latMin = extent[1];
                    latMax = extent[3];

                    lonCenter = (Number(lonMin) + Number(lonMax)) / 2;
                    latCenter = (Number(latMin) + Number(latMax)) / 2;
                    center = [latCenter, lonCenter];

                    // Zoom sur l'objet
                    bounds = [[latMin, lonMin], [latMax, lonMax]];
                } else if (features) {
                    bounds = geoJSON(features).getBounds();
                }

                this.$refs.myMap.mapObject.fitBounds(bounds);
                this.activeObject.center = this.$refs.myMap.mapObject.getCenter();
            }
            this.center = center;
            this.bounds = bounds;
            this.largeView = this.isLargeView();

            //si l'on veut recentrer la carte après dé-sélection ou validation
            //this.handleRecenter();
        },
        popup: function() {
            // Nettoie les anciennes popup
            if (this.popupLayer) {
                this.popupLayer.clearLayers();
                this.popupLayer.closePopup();
            }

            // Affiche la nouvelle popup
            if (
                this.popup &&
                this.popup.geom &&
                this.popup.geom.new_geom &&
                this.popup.geom.new_geom[0]
            ) {
                const features = this.getGeoJSONFeatures(
                    this.popup.geom.new_geom[0],
                    null,
                    this.popup.geom.color,
                );

                // Nouvelle popup
                this.popupLayer = geoJSON(features, {
                    style: function(feature) {
                        return feature.properties.style;
                    },
                });
                this.popupLayer.bindPopup(this.popup.content);
                this.popupLayer.addTo(this.$refs.myMap.mapObject);
                this.popupLayer.openPopup();
            }
        },
    },
    computed: {
        geojson: function() {
            let features = [];

            // Features de this.objectLayers
            if (this.objectLayers) {
                for (let i = 0; i < this.objectLayers.length; i++) {
                    const layer = this.objectLayers[i];
                    if (layer.new_geom && layer.color) {
                        if (Array.isArray(layer.new_geom)) {
                            for (let ii = 0; ii < layer.new_geom.length; ii++) {
                                features = [
                                    ...features,
                                    ...this.getGeoJSONFeatures(
                                        layer.new_geom[ii],
                                        null,
                                        layer.color,
                                    ),
                                ];
                            }
                        }
                    }
                }
            }

            // Features de this.activeObject
            const { new_geom, old_geom, color } = this.activeObject;
            features = [...features, ...this.getGeoJSONFeatures(new_geom, old_geom, color)];
            return features;
        },
        geojsonOptions: function() {
            const color = this.activeObject.color;
            return {
                pointToLayer: function(feature, latlng) {
                    return circleMarker(latlng, {
                        radius: 10,
                        fillColor: color,
                        color: color,
                        weight: 2.5,
                        opacity: 1,
                        fillOpacity: 0.5,
                    });
                },
                style: function(feature) {
                    return {
                        ...feature.properties.style,
                        // weight: 10,
                    };
                },
            };
        },

        //couches WMS de type base
        wmslayersBase() {
            return this.wmslayers.filter(function(el) {
                return el.type == 'base';
            });
        },

        //couches WMS de type overlay
        wmslayersOverlay() {
            return this.wmslayers.filter(function(el) {
                return el.type == 'overlay';
            });
        },

        //couches WMTS de type base avec protocole URL
        wmtslayersBaseUrl() {
            return this.wmtslayers.filter(function(el) {
                return el.type == 'base' && el.protocol == 'url';
            });
        },

        //couches WMTS de type overlay avec protocole URL
        wmtslayersOverlayUrl() {
            return this.wmtslayers.filter(function(el) {
                return el.type == 'overlay' && el.protocol == 'url';
            });
        },

        //couches WMTS de type base avec protocole REST
        wmtslayersBaseRest() {
            return this.wmtslayers.filter(function(el) {
                return el.type == 'base' && el.protocol == 'rest';
            });
        },

        //couches WMTS de type overlay avec protocole REST
        wmtslayersOverlayRest() {
            return this.wmtslayers.filter(function(el) {
                return el.type == 'overlay' && el.protocol == 'rest';
            });
        },
    },
    mounted() {
        this.loadFootprints().then(() => {
            this.loadSettings();
        });
        this.$http
            .get('/api/tile')
            .then((response) => {
                this.tiles = [
                    ...response.body.map((t) => ({
                        ...t,
                    })),
                ];
            })
            .catch((err) => {
                // error callback
                console.log('error loading map', JSON.stringify(err));
            });
        this.$http
            .get('/api/wms')
            .then((response) => {
                this.wmslayers = [
                    ...response.body.map((w) => ({
                        ...w,
                        transparent: true,
                        visible: false,
                    })),
                ];
                //console.log(JSON.stringify(this.wmslayers));
            })
            .catch((err) => {
                // error callback
                console.log('error loading map', JSON.stringify(err));
            });
        this.$http
            .get('/api/wmts')
            .then((response) => {
                this.wmtslayers = [
                    ...response.body.map((wt) => ({
                        ...wt,
                        transparent: true,
                        visible: false,
                    })),
                ];
            })
            .catch((err) => {
                // error callback
                console.log('error loading map', JSON.stringify(err));
            });
    },
    methods: {
        getGeoJSONFeatures: function(new_geom, old_geom, color) {
            const features = [];

            if (old_geom) {
                features.push({
                    type: 'Feature',
                    properties: {
                        style: {
                            color: '#ff0000',
                            fillColor: '#ff0000',
                            width: 1,
                            dashArray: '3,4',
                            dashOffset: '0',
                            fillOpacity: '0.1',
                        },
                    },
                    geometry: {
                        ...old_geom,
                    },
                });
            }

            if (new_geom) {
                features.push({
                    type: 'Feature',
                    properties: {
                        style: {
                            color,
                        },
                    },
                    geometry: {
                        ...new_geom,
                    },
                });
            }

            return features;
        },
        activeObject2: function() {
            let center = MAP_CENTER;
            let bounds = null;
            if (this.activeObject) {
                const { od_extent } = this.activeObject;
                var lonMin, lonMax, latMin, latMax, lonCenter, latCenter;

                const extent = od_extent.split(';');
                lonMin = extent[0];
                lonMax = extent[2];
                latMin = extent[1];
                latMax = extent[3];

                lonCenter = (Number(lonMin) + Number(lonMax)) / 2;
                latCenter = (Number(latMin) + Number(latMax)) / 2;
                center = [latCenter, lonCenter];

                // Zoom sur l'objet
                bounds = [[latMin, lonMin], [latMax, lonMax]];
                this.$refs.myMap.mapObject.fitBounds(bounds);
            }
            this.center = center;
            this.bounds = bounds;
            this.largeView = this.isLargeView();
            //si l'on veut recentrer la carte après dé-sélection ou validation
            //this.handleRecenter();
        },
        extendView: function() {
            //Centre la carte sur un point et un niveau de zoom
            const map = this.$refs.myMap.mapObject;
            let center = MAP_CENTER;
            let zoom = ZOOM;
            map.setView(center, zoom);
        },
        adjustCenter: function(center, offset = 0) {
            const map = this.$refs.myMap.mapObject;
            const targetZoom = map.getZoom();
            const targetPoint = map.project(center, targetZoom).subtract([offset / 2, 0]);
            const targetLatLng = map.unproject(targetPoint, targetZoom);
            map.setView(targetLatLng, targetZoom);
        },
        eventClick: function(e) {
            this.$emit('event:click', e);
        },
        handleSearch: function(e) {
            console.log('me', e);
        },
        handleRecenter: function() {
            //const map = this.$refs.myMap.mapObject;
            //this.adjustCenter(this.center, Number.parseInt(this.overlayOffset));
            console.log(this.activeObject);
            //map.fitBounds(this.activeObject.bounds);
        },
        handleHelp: function(e) {
            console.log('me', e);
        },
        zoomEnd: function() {
            this.largeView = this.isLargeView();
        },
        // Fonction déclenchée si carte déplacée
        // émet updateBounds récupérable par le parent
        updateBounds: debounce(function(bounds) {
            // Donne la valeur à OsmMap.data.bounds
            this.bounds = bounds;
            //this.$emit('update-bounds', bounds);
            this.$emit('updateBounds', bounds);
            // TEST ALERTE
            //alert(JSON.stringify(this.bounds));
        }, 1500),

        // Zoom à partir duquel l'objet est affiché sous forme de point
        isLargeView: function() {
            return this.$refs.myMap && this.$refs.myMap.mapObject._zoom < 13;
        },
        loadSettings() {
            this.$http
                .get('/api/setting')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));

                        if (this.settings.osm_footprint) {
                            const emprise = this.getFirstFootprint();
                            if (emprise) {
                                this.emprise.id = emprise.id;
                                this.emprise.geojson = emprise.geom;
                                this.emprise.options.style.color = this.settings.osm_footprint_pen_color;
                                this.emprise.options.style.opacity = this.settings.osm_footprint_pen_opacity;
                                this.emprise.options.style.fillColor = this.settings.osm_footprint_fill_color;
                                this.emprise.options.style.fillOpacity = this.settings.osm_footprint_fill_opacity;
                                this.emprise.options.style.weight = this.settings.osm_footprint_width;

                                //Centre et zoome sur l'emprise GeoJSON après le chargement
                                this.fitEmprise();
                            } else {
                                console.error('Emprise par défaut non valide');
                            }
                        } else {
                            console.error('Aucune emprise par défaut configurée');
                        }
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
        /**
         * Si l'emprise par défaut fait partie des emprises de l'utilisateur alors c'est l'emprise par défaut, autrement c'est la première emprise trouvée
         * DESACTIVE, on se place sur la première de la liste, comme pour le chargement initial des objets
         */
        getFirstFootprint() {
            //return this.getFootprintById(this.settings.osm_footprint) || this.footprints[0];
            return this.footprints[0];
        },
        getFootprintById(id) {
            return this.footprints.find((e) => {
                return e.id == id;
            });
        },
        loadFootprints() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/api/user-footprint')
                    .then((response) => {
                        if (response && response.body) {
                            this.footprints = response.body;
                            this.footprintsList = [];
                            for (let i = 0; i < this.footprints.length; i++) {
                                this.footprintsList.push({
                                    id: this.footprints[i].id,
                                    text: this.footprints[i].name,
                                });
                            }
                            this.$emit('default:emprise', this.footprints[0]);
                            resolve();
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        reject();
                    });
            });
        },
        changeEmprise(evt) {
            if (evt.id) {
                const emprise = this.getFootprintById(evt.id);
                this.emprise.id = emprise.id;
                this.emprise.geojson = emprise.geom;
                this.fitEmprise();
                this.$emit('change:emprise', this.emprise);
            }
        },
        // Calcule les bounds et centre sur l'emprise GeoJSON
        // https://www.npmjs.com/package/geojson-bounds
        fitEmprise() {
            var st = require('geojson-bounds');
            const geom = this.emprise.geojson;
            const map = this.$refs.myMap.mapObject;
            var lonsMin, lonsMax, latsMin, latsMax;
            lonsMin = st.xMin(geom);
            lonsMax = st.xMax(geom);
            latsMin = st.yMin(geom);
            latsMax = st.yMax(geom);
            this.emprise.bounds = [[latsMin, lonsMin], [latsMax, lonsMax]];
            map.fitBounds(this.emprise.bounds);
        },
    },
    components: {
        //SearchControl,
        LMap,
        LControlLayers,
        LControlZoom,
        LControl,
        LTileLayer,
        'l-wms-tile-layer': LWMSTileLayer,
        LCircleMarker,
        LRectangle,
        LGeoJson,
        LControlScale,
        Select,
        //LMarker,
        //LLayerGroup,
    },
};
</script>

<style lang="scss">
#map {
    width: 100vw;
    height: 100vh;

    .leaflet-control-layers {
        .leaflet-control-layers-toggle {
            width: 30px;
            height: 30px;
            background-size: 66%;
        }
    }

    .select-footprint {
        .dropdown {
            background-color: white;
            border-radius: 4px;

            .dropdown-toggle {
                margin: 4px 15px;
            }

            .dropdown-menu {
                top: -10px;
                right: calc(100% + 5px);
                left: auto;

                .dropdown-item > a {
                    width: 100%;
                    text-align: left;
                }
            }
        }
    }
}
</style>
